/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createActiveCustomersKpiFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ActiveCustomersKpi, type ErrorResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/active-customers
 */
export interface ActiveCustomersRequestBuilder extends BaseRequestBuilder<ActiveCustomersRequestBuilder> {
    /**
     * Counts the distinct customers who placed at least one order in the period. Active here is measured by ordering, not by account state: a customer whose record is switched off still counts if they ordered inside the window, and a perfectly healthy account that ordered nothing does not. Each customer counts once however many orders they placed. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders reports zero.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ActiveCustomersKpi>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ActiveCustomersRequestBuilderGetQueryParameters> | undefined) : Promise<ActiveCustomersKpi | undefined>;
    /**
     * Counts the distinct customers who placed at least one order in the period. Active here is measured by ordering, not by account state: a customer whose record is switched off still counts if they ordered inside the window, and a perfectly healthy account that ordered nothing does not. Each customer counts once however many orders they placed. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders reports zero.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ActiveCustomersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Counts the distinct customers who placed at least one order in the period. Active here is measured by ordering, not by account state: a customer whose record is switched off still counts if they ordered inside the window, and a perfectly healthy account that ordered nothing does not. Each customer counts once however many orders they placed. Both bounds are inclusive and are compared against the order date as a full timestamp, so an end date sent without a time stops at midnight. A period with no orders reports zero.
 */
export interface ActiveCustomersRequestBuilderGetQueryParameters {
    /**
     * End of the period, inclusive. Compared against the order date as a full timestamp, so adate with no time stops at midnight; it must not be earlier than the start date.
     */
    endDate?: Date;
    /**
     * Start of the period, inclusive. Compared against the order date as a full timestamp.
     */
    startDate?: Date;
}
/**
 * Uri template for the request builder.
 */
export const ActiveCustomersRequestBuilderUriTemplate = "{+baseurl}/api/analytics/active-customers?endDate={endDate}&startDate={startDate}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ActiveCustomersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ActiveCustomersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createActiveCustomersKpiFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
